import { Card } from "@mui/material";
import "./Notifications.scss";
import { useEffect, useState } from "react";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import { API_RESPONSE, NOTIFICATION_CONSTANTS, NUMBER_CONSTANTS, TOASTER_CONFIGS } from "../../../Utilities/Constants/Constants";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CategoryValidationDialog from "../../../Shared/CategoryValidationDialog/CategoryValidationDialog";

const Notifications = () => {
  const [newNotifications, setNewNotifications] = useState<any>([]);
  const [seenNotifications, setSeenNotifications] = useState<any>([]);
  const [notificationDetail, setNotificationDetail] = useState<any>({});
  const [newIndex, setNewIndex] = useState(API_RESPONSE.NULL);
  const [seenIndex, setSeenIndex] = useState(API_RESPONSE.NULL);
  const [categoryValidationMessage, setCategoryValidationMessage] = useState<any>("")
  const [open, setOpen] = useState<boolean>(false)
  const [categoryValidationDetails, setCategoryValidationDetails] = useState<any>("")
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false)
  }

  const notificationUser: any = useSelector((state: any) => {
    return state.notificationReducer.notification;
  });

  useEffect(() => {
    getNotifications();
  }, [notificationUser])

  /* Getting notifications list on initialize */
  /*  useEffect(() => {
     getNotifications();
   }, []); */

  /* Notifications list API call */
  const getNotifications = () => {
    axiosInstance
      .get(API_END_POINTS.NOTIFICATIONS_LIST)
      .then((response: any) => {
        if (response.data.status === API_RESPONSE.TRUE) {
          setNewNotifications(response.data.result.data.new);
          setSeenNotifications(response.data.result.data.seen);
        }
      });
  };

  /*geting seteled category detailes */
  const getValidateCategoryDetailes = () => {
    axiosInstance.get(API_END_POINTS.MANAGE_CATEGORY)
    .then((res:any)=>{
      if(res.data[API_RESPONSE.STATUS]) {
        setCategoryValidationDetails(res.data.result.data)
        setOpen(true)
      }
    })
  }

  /*Category validation */
  const validateCategory = () => {
    let payload = {
      "category_id": +notificationDetail?.redirect_info?.category_id || null
    }
    axiosInstance.post(API_END_POINTS.MANAGE_CATEGORY, payload)
    .then(
      (res:any) => {
        if(!res.data.result.data.status) {
          getValidateCategoryDetailes()
          setCategoryValidationMessage(res.data.message)
        } else {
          navigate(`/profile`);
        }
      }
    ).catch(()=>{
    })
  } 
  
  /*undate or accept commision change */
  const putValidationCategory = () => {
    let payload = {
      "id":categoryValidationDetails?.id, 
      "category_id": categoryValidationDetails?.category_id ,
      "teach_service_provider_id": categoryValidationDetails?.teach_service_provider,
      "status":"accepted"
    }
    axiosInstance.put(API_END_POINTS.MANAGE_CATEGORY, payload)
    .then((res:any)=>{
      if(res.data[API_RESPONSE.STATUS]) {
        handleClose();
        navigate(`/profile`);
      }
    })
  }

  /* Time calculation logic to show in list  */
  const calculateTime = (value: any) => {
    const now: any = new Date();
    const time: any = new Date(value);
    const timeDifference = now - time;
    const seconds = Math.floor(timeDifference / NUMBER_CONSTANTS.THOUSAND);
    const minutes = Math.floor(seconds / NUMBER_CONSTANTS.SIXTY);
    const hours = Math.floor(minutes / NUMBER_CONSTANTS.SIXTY);
    const days = Math.floor(hours / NUMBER_CONSTANTS.TWENTY_FOUR);
    if (days >= NUMBER_CONSTANTS.ONE) {
      return days === NUMBER_CONSTANTS.ONE ? NOTIFICATION_CONSTANTS.ONE_DAY : `${days}` + NOTIFICATION_CONSTANTS.DAYS_AGO;
    } else if (hours >= NUMBER_CONSTANTS.ONE) {
      return hours === NUMBER_CONSTANTS.ONE ? NOTIFICATION_CONSTANTS.ONE_HOUR : `${hours} ` + NOTIFICATION_CONSTANTS.HOURS_AGO;
    } else if (minutes >= NUMBER_CONSTANTS.ONE) {
      return minutes === NUMBER_CONSTANTS.ONE ? NOTIFICATION_CONSTANTS.ONE_MINUTE : `${minutes}` + NOTIFICATION_CONSTANTS.MINUTES_AGO;
    } else {
      return `${NOTIFICATION_CONSTANTS.JUST_NOW}`;
    }
  };

  const onViewNotification = (index: any, type: any) => {
    if (type === NOTIFICATION_CONSTANTS.NEW) {
      setNewIndex(index);
      setSeenIndex(API_RESPONSE.NULL);
      setNotificationDetail(newNotifications[index]);
      markNotificationRead(newNotifications[index].id);
    } else {
      setNewIndex(API_RESPONSE.NULL);
      setSeenIndex(index);
      setNotificationDetail(seenNotifications[index]);
    }
  };

  /* API to mark new notification as read */
  const markNotificationRead = (id: any) => {
    axiosInstance.get(API_END_POINTS.NOTIFICATION_READ + "?id=" + id).then((response: any) => {
      if (response.data.status === API_RESPONSE.TRUE) {

      }
    })
  };

  const onRedirect = () => {
    switch (notificationDetail?.redirect_info?.sp_path) {
      case "view_bookings":
        navigate(`/manage-bookings/calender/${notificationDetail?.redirect_info?.session_id}`);
        break;

      case "chat":
        navigate(`/chat/${notificationDetail?.redirect_info?.room_name}`);
        break;

      case "meet_link":
        if (notificationDetail?.redirect_info?.meet_link) {
          window.open(notificationDetail?.redirect_info?.meet_link, '_blank')
        } else {
          toast.error('This is on-premises session', TOASTER_CONFIGS);
        }
        //  else if (notificationDetail?.redirect_info?.key === 'session_start') {
        //   navigate(`/manage-bookings/calender/${notificationDetail?.redirect_info?.session_id}`, {
        //     state: { notification_redirect: true, notification_redirect_Detailes: notificationDetail?.redirect_info }
        //   });
        // }
        break;

      case "profile":
        if(notificationDetail?.redirect_info?.key === "admin_category_update") {
          validateCategory()
        } else {
          navigate(`/profile`);
        }
        break;

      case "my_session":
        navigate(`/manage-bookings/calender/${notificationDetail?.redirect_info?.booking_id}`);
        break;

      case "reschedule":
        navigate(`/manage-bookings/calender/${notificationDetail?.redirect_info?.session_id}`, {
          state: { notification_redirect: true, notification_redirect_Detailes: notificationDetail?.redirect_info }
        });
        break;

      case "cancelations":
        if ((notificationDetail?.redirect_info?.key === "user cancel request") || (notificationDetail?.redirect_info?.key === "user cancel request rejected")) {
          navigate(`/manage-bookings/list/${notificationDetail?.redirect_info?.session_id}`);
        } else {
          navigate(`/manage-cancelations`);
        }

        break;

      /*  case "cancelations":
         navigate(`/manage-cancelations`);
         break; */

    }
  };


  return (
    <div className="notification-wrapper">
      <div className="row">
        <div className="col-md-7">
          <div className="new-notifications-wrapper">
            <h5 className="ps-2">New</h5>
            <Card className="new-not-card">
              {newNotifications.length > NUMBER_CONSTANTS.ZERO && <div>
                {
                  newNotifications.map((notification: any, index: any) => {
                    return (
                      <div key={index + 1} className={newIndex === index ? "seen-notification-data-active" : "notification-data"} onClick={() => { onViewNotification(index, 'new') }}>
                        <div className="notification-image">
                          <img
                            className="user-profile"
                            src={notification?.image ? notification?.image : "https://fixxerapp.s3.ap-south-1.amazonaws.com/pexels-pixabay-220453%20%281%29%20%281%29.jpg"}
                          />
                        </div>
                        <div className="notification-content">
                          <p className="notification-header">
                            {notification?.title}
                          </p>
                          <p className="notification-time">{calculateTime(notification?.created_on)}</p>
                        </div>
                      </div>
                    )
                  })
                }
              </div>}
              {
                newNotifications.length === NUMBER_CONSTANTS.ZERO && <>
                  <div className="d-flex justify-content-center p-5">
                    No New Notifications available
                  </div>
                </>
              }


            </Card>
          </div>
          <div className="seen-notifications-wrapper">
            <h5 className="ps-2">Seen</h5>
            <Card className="new-not-card">
              {seenNotifications.length > NUMBER_CONSTANTS.ZERO && <div>
                {
                  seenNotifications.map((data: any, i: any) => {
                    return (
                      <div key={i + 1} className={seenIndex === i ? "seen-notification-data-active" : "notification-data"} onClick={() => { onViewNotification(i, 'seen') }}>
                        <div className="notification-image">
                          <img
                            className="user-profile"
                            src={data?.image ? data?.image : "https://fixxerapp.s3.ap-south-1.amazonaws.com/pexels-pixabay-220453%20%281%29%20%281%29.jpg"}
                          />
                        </div>
                        <div className="notification-content">
                          <p className="notification-header">
                            {data?.title}
                          </p>
                          <p className="notification-time">{calculateTime(data?.created_on)}</p>
                        </div>
                        <hr className="horizontal-line" />
                      </div>
                    )
                  })
                }
              </div>}

              {
                seenNotifications.length === NUMBER_CONSTANTS.ZERO && <>
                  <div className="d-flex justify-content-center p-5">
                    No notifications available!
                  </div>
                </>
              }

            </Card>
          </div>
        </div>
        <div className="col-md-5">
          {notificationDetail?.created_on && <Card className="new-not-card-right" onClick={onRedirect}>
            <div className="notification-detail">
              <img
                className="not-detail-profile"
                src={notificationDetail?.image ? notificationDetail?.image : "https://fixxerapp.s3.ap-south-1.amazonaws.com/pexels-pixabay-220453%20%281%29%20%281%29.jpg"}
              />
              <p className="notification-detail-content">
                {notificationDetail?.description}
              </p>
              <div className="timer-wrap">
                <p className="notification-detail-time">{calculateTime(notificationDetail?.created_on)}</p>
                <p className="click-text">click here</p>
              </div>

            </div>
          </Card>}

          <CategoryValidationDialog
            open={open}
            onClose={handleClose}
            message={categoryValidationMessage}
            update={putValidationCategory}
          />

        </div>
      </div>
    </div>
  );
};

export default Notifications;